import {Aggregator} from '@xh/hoist/data';

/**
 * Aggregates avgPrice (cost/share) as a quantity-weighted average across positions:
 *   avgPrice = Σ(totalCost) / Σ(quantity)
 *
 * This gives the blended cost basis per share when the same security is held across
 * multiple portfolios with different average prices.
 */
export class WeightedAvgPriceAggregator extends Aggregator {
    override aggregate(rows, _fieldName) {
        let totalCost = 0,
            totalQty = 0;

        this.forEachLeaf(rows, leaf => {
            const cost = leaf.data['totalCost'];
            const qty = leaf.data['quantity'];
            if (cost != null && qty != null) {
                totalCost += cost;
                totalQty += qty;
            }
        });

        return totalQty !== 0 ? totalCost / totalQty : null;
    }
}
